<div class="dn-container">
  <h3 class="attachment-title">{{ sectionTitleKey | translate }}</h3>
  <div class="dn-card">
    <div class="dn-card-left">
      <div class="dn-file-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C6C6C" stroke-width="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <path d="M14 2v6h6"></path>
        </svg>
      </div>
    </div>

    <div class="dn-card-middle">
      <div class="dn-card-title">{{ fileName || (sectionTitleKey | translate) }}</div>

      <ng-container *ngIf="deliveryNoteData?.pdfKind === PdfKind.Url; else defaultDescription">
        <div class="dn-card-subtitle">{{ 'delivery-note.link_description' | translate }}</div>
        <a [href]="fileUrl" target="_blank" rel="noopener noreferrer" class="dn-link">{{ fileName }}</a>
      </ng-container>

      <ng-template #defaultDescription>
        <div *ngIf="deliveryNoteData" class="dn-card-subtitle">{{
          'delivery-note.delivery-note_section_description' | translate }}</div>
      </ng-template>
    </div>

    <div class="dn-card-right">
      <app-delivery-note-upload-button
        [hasFile]="hasFile"
        [fileName]="fileName"
        [isLoading]="isLoading"
        [showLabel]="false"
        [menuActions]="menuActions"
        (upload)="openUploadModal()">
      </app-delivery-note-upload-button>
    </div>
  </div>
</div>